<template>
	<div class="reservation-layout">
		<div class="reservation-layout__nav-container">
			<nav v-if="route.path === localePath('cars')" ref="navRef" class="reservation-layout__nav">
				<GlobalHeader booker />
			</nav>
			<nav v-else ref="navRef" class="reservation-layout__nav">
				<ReservationTopBar ref="reservationTopBarRef" class="reservation-layout__topbar" />
			</nav>
		</div>
		<GlobalBooker nav />
		<slot />
		<GlobalIntercomFacade />
	</div>
</template>

<script setup lang="ts">
const route = useRoute()
const topBarData = ref<any[]>([])
const step = ref(0)
const reservationTopBarHeight = ref(0)
const navRef = ref<HTMLElement | null>(null)
const navHeight = computed(() => {
	return navRef.value?.clientHeight
})
const localePath = useLocalePath()
provide('navHeight', navHeight)
provide('topBarData', topBarData)
provide('step', step)
provide('reservationTopBarHeight', reservationTopBarHeight)

topBarData.value = [{ title: 'select_a_vehicle', active: true, url: 'cars' }, { title: 'insurance_and_allowances' }, { title: 'booking', last: true }]

watch(
	() => step.value,
	() => {
		topBarData.value.forEach((point) => {
			point.active = false
			point.done = false
		})
		for (let i = 0; i < step.value; i++) {
			topBarData.value[i].done = true
		}
		topBarData.value[step.value].active = true
	},
	{ immediate: true },
)
</script>

<style lang="scss">
@import './reservation.scss';
</style>
